import React, { useState, useEffect } from "react";
import { IconButton, Typography, Grid } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import BusinessIcon from "@mui/icons-material/Business";

import Modal from "../../components/Modal/Modal";
import formFields from "../../config/formFields.json";

import { useLoading } from "../../contexts/LoadingContext";
import FormValidation from "../../components/FormValidation/FormValidation";

const AddSkill = ({
    open,
    onClose,
    initialData = null,
    onSubmit,
    skillCategory = [],
}) => {
    const isEdit = !!initialData;
    const initialFormState = {
        skill_name: "",
        skill_cat_id: null,
        skill_description: ""
    };

    const [formData, setFormData] = useState(initialFormState);
    const [errorModal, setErrorModal] = useState(null);
    const { showLoading, hideLoading } = useLoading();
    const getOptionsForField = (fieldName) => {
        switch (fieldName) {
            case "skill_cat_id":
                return skillCategory.map((skillcategory) => ({
                    value: skillcategory.skill_category_id.toString(),
                    label: skillcategory.skill_cat_name,
                }));
            default:
                return [];
        }
    };

    useEffect(() => {
        if (open) {
            if (initialData) {
                setFormData({
                    skill_name: initialData.skill_name || "",
                    skill_cat_id:initialData.skill_cat_id?.toString() || null,
                    skill_description: initialData.skill_description || ""
                });
            } else {
                setFormData(initialFormState);
            }
        } else {
            setFormData(initialFormState);
        }
        setErrorModal(null);
    }, [initialData, open]);

    const handleSubmit = async (e) => {
        // e.preventDefault();
        setErrorModal(null);

        try {
            showLoading();
            await onSubmit({
                ...e
            });
            setFormData(initialFormState);
        } catch (error) {
            setErrorModal({
                type: "error",
                title: "Action Failed",
                message: error.message || "Something went wrong",
            });
        } finally {
            hideLoading();
        }
    };

    const handleClose = () => {
        setFormData(initialFormState);
        setErrorModal(null);
        onClose();
    };

    const handleErrorModalClose = () => {
        setErrorModal(null);
    };

    return (
        <>

            <FormValidation
                modelWidth={"60vw"}
                open={open}
                onClose={handleClose}
                initialData={formData}
                onSubmit={handleSubmit}
                formFields={formFields.skill.basic.fields}
                title="Skill"
                icon={BusinessIcon}
                isEdit={isEdit}
                getOptionsForField={getOptionsForField}
            />

            {errorModal && (
                <Modal
                    type={errorModal.type}
                    title={errorModal.title}
                    message={errorModal.message}
                    onClose={handleErrorModalClose}
                />
            )}
        </>
    );
};

export default AddSkill;
